import { render } from "./streaming.vue?vue&type=template&id=d40a7212&scoped=true"
import script from "./streaming.vue?vue&type=script&lang=js"
export * from "./streaming.vue?vue&type=script&lang=js"

import "./streaming.vue?vue&type=style&index=0&id=d40a7212&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d40a7212"

export default script